import { useEffect, useState, useRef } from "react";
import { useRouter } from "next/router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import Image from "next/image";
import CareerHackersLogo from "@/public/images/career hackers.svg";
import { useAuth } from "@/hooks/useAuth";

const Login = () => {
  const router = useRouter();

  const { authenticating, login, isAuthenticated } = useAuth();  

  const [showPassword, setShowPassword] = useState(false);
  const emailRef = useRef();
  const passwordRef = useRef();

  useEffect(() => {
    if (isAuthenticated) {
      router.push("/dashboard/assessments");
    }
  }, [isAuthenticated]);

  const handleEnter = (e) => {
    if (e.key === "Enter") handleLogin();
  };

  useEffect(() => {
    window.addEventListener("keydown", handleEnter);

    return () => {
      window.removeEventListener("keydown", handleEnter);
    };
  }, []);

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleLogin = async () => {
    const email = emailRef.current.value;
    const password = passwordRef.current.value;

    try {
      if (email.trim() === "" || password.trim() === "")
        throw new Error("EmptyException");

      await login(email, password);
    } catch (error) {
      if (error.message === "EmptyException") {
        alert("Email or password cannot be empty");
      } else if (error.message === "InvalidException") {
        alert("Invalid email or password");
      } else {
        alert("Something went wrong. Please try again later.");
      }
    }
  };

  if (authenticating) {
    return (
      <div className="fixed inset-0 flex justify-center items-center">
        Loading...
      </div>
    );
  }

  return (
    <div className="login-wrapper">
      <div className="section-left px-9 bg-[white]">
        <div className="header mb-7">
          <div className="mb-[30px]">
            <Image
              src={CareerHackersLogo}
              alt="Career Hackers"
              style={{ marginLeft: "-15px" }}
            />
          </div>
          <div className="text-[#747474] text-[14px] w-[90%] mb-20 leading-[1.2]">
            Welcome to Career Hackers Talent Solution, please login below to
            start.
          </div>
        </div>
        <form className="flex flex-col justify-center w-full">
          <div className="input-container">
            <div className="input-title">Email</div>
            <input
              className="styled-input"
              ref={emailRef}
              type="email"
              autoComplete="email"
            />
          </div>

          <div className="input-container">
            <div className="input-title">Password</div>
            <div className="relative styled-input">
              <input
                className="flex-1 w-full"
                type={showPassword ? "text" : "password"}
                ref={passwordRef}
                autoComplete="current-password"
              />
              <button
                type="button"
                className="flex-0 px-3 flex items-center text-gray-500"
                onClick={toggleShowPassword}
                title={showPassword ? "Hide password" : "Show password"}
              >
                <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
              </button>
            </div>
          </div>

          <div className="submit-btn" onClick={handleLogin}>
            Log in
          </div>
        </form>
      </div>
      <div className="section-right">
        <div className="cover"></div>
      </div>
    </div>
  );
};

export default Login;
